import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/configuration/setup/store';

interface MfeBottomSheetPayload {
    title: string;
    url: string;
}

interface MfeBottomSheetState {
    isOpen: boolean;
    title: string | null;
    url: string | null;
}

const initialState: MfeBottomSheetState = {
    isOpen: false,
    title: null,
    url: null,
};

const mfeBottomSheetSlice = createSlice({
    name: 'mfeBottomSheet',
    initialState,
    reducers: {
        openMfeBottomSheet: (state, action: PayloadAction<MfeBottomSheetPayload>) => {
            state.isOpen = true;
            state.title = action.payload.title;
            state.url = action.payload.url;
        },
        closeMfeBottomSheet: (state) => {
            state.isOpen = false;
            state.title = null;
            state.url = null;
        },
    },
});

// Actions
export const { openMfeBottomSheet, closeMfeBottomSheet } = mfeBottomSheetSlice.actions;

// Selectors
export const getMfeBottomSheetIsOpen = (state: RootState) => state.mfeBottomSheet.isOpen;
export const getMfeBottomSheetTitle = (state: RootState) => state.mfeBottomSheet.title;
export const getMfeBottomSheetUrl = (state: RootState) => state.mfeBottomSheet.url;

export default mfeBottomSheetSlice.reducer;
